import moment from 'moment';

import { UserRole } from "./user-role";
import { User } from "./user";
import { ApiText } from "../api-text";
import { Language } from '../language';
import { LicenceType } from './licence-type';
import { Organism } from '../organism/organism';
import { LicenceAdress } from './licence-address';


export class Licence {
    code: string;
    accountNumber?: string;
    businessNumber?: string;
    address: LicenceAdress;
    startDate?: Date;
    endDate?: Date;
    communication?: string;

    licenceType: LicenceType;
    organism: Organism;
    language: Language;
    text: ApiText;
    banker?: User;
    term?: 0;
    terminationDate: Date;
    billingMonth: string;
    isAutomaticallyDebited: boolean;

    roles: UserRole[];
    users: User[];

    constructor(name: string, organism: Organism, language: Language, licenceType: LicenceType,
            isPublic: boolean, communication: string, isAutomaticallyDebited: boolean, accountNumber?: string,
            businessNumber?: string, address?: LicenceAdress, banker?: User, term?: 0, billingMonth?: string) {
        organism.isPublic = isPublic;
        this.organism = organism;
        this.language = language;
        this.licenceType = licenceType;
        this.banker = banker || null;
        this.communication = communication || "";

        this.text = new ApiText(name);
        this.startDate = moment().toDate();
        this.endDate = moment().add(3, 'y').toDate();
        this.accountNumber = accountNumber || "";
        this.businessNumber = businessNumber || "";
        this.address = address || new LicenceAdress();
        this.term = term;
        this.isAutomaticallyDebited = isAutomaticallyDebited;
        this.billingMonth = billingMonth || "";

        this.roles = [];
        this.users = [];
    }
}
